import axios from 'axios'
import { toast } from 'react-toastify';

const API_URL = `${process.env.REACT_APP_API_URL}/auth`;

export const registerAction = (authData, navigate) => async (dispatch) => {
    try {
        const { data } = await axios.post(`${API_URL}/register`, authData);
        dispatch({ type: "REGISTER", payload: data })
    } catch (error:any) {
        toast(error.response.data.msg, {
            position: "top-right",
            autoClose: 5000,
        });
    }
}

export const loginAction = (authData, navigate) => async (dispatch) => {
    try {
        const { data } = await axios.post(`${API_URL}/login`, authData)
        await dispatch({ type: "LOGIN", payload: data })
        navigate("/cms/home");
    } catch (error:any) {
        console.error("Login Error:", error);
        toast(error.response.data.msg, {
            position: "top-right",
            autoClose: 5000,
        });
    }
}

export const logoutAction = () => async (dispatch) => {
    dispatch({ type: "LOGOUT" });
    localStorage.removeItem("auth");
    window.location.href = "/auth";
}
